<template>
  <div class="contact">
    <div>
      <span class="label">Branch</span><span>{{ assignment.branch_name }}</span>
    </div>
    <div>
      <span class="label">Start</span><span>{{ assignment.start_date | formatDate }}</span>
    </div>
    <div>
      <span class="label">Stop</span><span>{{ assignment.stop_date | formatDate }}</span>
    </div>
    <div>
      <span class="label">Pay Period</span
      ><span>{{ assignment.pay_period_type | readable | capitalize }}</span>
    </div>
    <div>
      <span class="label">Submittal Period</span
      ><span>{{ assignment.submittal_period_type | readable | capitalize }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssignmentDisplayLink',
  props: {
    assignment: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.contact {
  margin-bottom: 10px;
  padding: 15px;
  border-left: 1px solid $light-grey-1;
  &:hover {
    padding: 15px;
    cursor: pointer;
    background-color: $mid-blue;
    border-radius: 8px;
  }
  .contact-email {
    font-weight: normal;
    color: $primary-blue;
  }
  .contact-phone {
    font-weight: normal;
    color: $mid-grey-2;
  }

  div {
    padding: 5px 0;
  }
  span {
    font-weight: normal;
    display: inline-block;
    &.label {
      font-weight: bold;
      width: 120px;
    }
  }
}
</style>
